const getLandingUrl = (url) => {
    return "https://" + window.location.href.split('/')[2].replace("app.", "");
}

const getAppUrl = (url) => {
    return "https://app." + window.location.href.split('/')[2].replace("app.", "");
}


export {getLandingUrl, getAppUrl};